import api from "!../../../../../../releases/86681365aceec5b9c5a6b545b50a36662e4d229f/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../releases/86681365aceec5b9c5a6b545b50a36662e4d229f/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[1]!../../../../../../releases/86681365aceec5b9c5a6b545b50a36662e4d229f/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[2]!../../../../../../releases/86681365aceec5b9c5a6b545b50a36662e4d229f/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[8].oneOf[1].use[3]!./admin.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};